<template>
    <div>
        <div class="content-caption dashed">
            <span>共享配件调配单信息</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">服务商</label>
                </div>
                <div class="form-value width-2x">
                    <el-select v-model="adjustApplyFormInfo.servicerName" :disabled="formId != null" filterable @change="changeServicerInfo">
                        <el-option v-for="item in sharaAccServicerList" :label="item.servicerName" :value="item.servicerId"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">调入仓库</label>
                </div>
                <div class="form-value width-2x">
                    <el-select v-model="adjustApplyFormInfo.warehouseName" :disabled="formId != null" filterable @change="changeWarehouseInfo">
                        <el-option v-for="item in sharaAccWarehouseList" :label="item.warehouseName" :value="item.warehouseId"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">备货用途</label>
                </div>
                <div class="form-value width-2x">
                    <el-radio-group v-model="adjustApplyFormInfo.accPreStkUsage">
                        <el-radio :label="item.value" v-for="item in accPreStkUsages">{{item.text}}</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <div class="simple-row">
            <div class="left">
                <el-checkbox v-model="adjustApplyFormInfo.autoApply" @change="autoApplyChange">自动申请</el-checkbox>
                <span v-if="adjustApplyFormInfo.autoApply" class="swb-btn swb-btn-mini ml20" @click="upLoadApplyFiles">申请附件</span>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>配件信息</span>
        </div>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="getShareAccStockByWarehouseId()">选择配件</button>
            </div>
        </div>
        <div class="table-layout">
            <el-form :model="adjustApplyFormInfo" ref="adjustApplyFormInfo">
                <el-table ref="multipleTable" :data="adjustApplyFormInfo.itemList" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column align="left" prop="accName" label="配件名称" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-tag type="success" v-if="scope.row.specificFlag">个</el-tag>
                            <span>{{scope.row.accName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" width="130" prop="catName" label="分类" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" width="130" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" width="130" prop="modelSpec" label="规格" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" width="100" label="申请数量">
                        <template slot-scope="scope">
                            <el-form-item :prop="'itemList.' + scope.$index + '.quantity'" :rules="{validator: inputQuantity, trigger: 'blur'}">
                                <el-input class="input-content-right" type="text" v-model.number="scope.row.quantity"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column width="80" prop="unit" label="单位" align="center"></el-table-column>
                    <el-table-column align="left" width="220" label="申请描述" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item :prop="'itemList.' + scope.$index + '.memo'">
                                <el-input class="input-content-right" type="textarea" v-model="scope.row.memo"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" width="80" label="操作">
                        <template slot-scope="scope">
                            <a class="swb-btn-link" @click="removeAcc(scope.$index)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { showShareAccSelect } from './selectDlg'
    import { openAdjustApplyFormFileUploadDlg, openMerchtAccDefListSelectDlg } from './selectDlg'
    //
    import shareAccApi from '../../api/shareAcc';
    //
    export default {
        name: 'swb-adjust-apply-form-save',
        desc: '共享配件调配单-新增、编辑',
        props: ['thisComId', 'formId'],
        data: function () {
            return {
                adjustApplyFormInfo: {
                    itemList: [],
                    autoApply: true,
                    accPreStkUsage: null,
                },
                appturnFileList: [],
                //
                sharaAccServicerList: [],
                sharaAccServicerListMap: {},
                sharaAccWarehouseList: [],
                sharaAccWarehouseListMap: {},
                accPreStkUsages: null,
            }
        },
        created: function () {
            let accPreStkUsages = getEnumList("accPreStkUsage");
            accPreStkUsages.splice(0, 1);
            this.accPreStkUsages = Utils.merge([], accPreStkUsages);
            //
            if(!Utils.isNoB(this.formId)) {
                this.getShareAccAdjustApplyFormInfo();
            }
            // 获取-共享仓库信息 - 默认
            this.getShareAccServicerList();
        },
        methods: {
            getShareAccAdjustApplyFormInfo: function () {
                let self = this;
                let postData = {
                    id: self.formId,
                };
                let theLoad = MsgBox.loading();
                shareAccApi.getShareAccAdjustApplyFormById(postData, function (result) {
                    theLoad.close();
                    if(result.type == 'info') {
                        //
                        self.adjustApplyFormInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getShareAccServicerList: function () {
                let self = this;
                let theLoad = MsgBox.loading();
                shareAccApi.getShareAccServicerList({
                    custComId: self.thisComId
                }, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let sharaAccServicerList = result.data;
                        //
                        if(sharaAccServicerList != null && sharaAccServicerList.length > 0) {
                            let adjustApplyFormInfo = self.adjustApplyFormInfo;
                            adjustApplyFormInfo.servicerId = sharaAccServicerList[0].servicerId;
                            adjustApplyFormInfo.servicerName = sharaAccServicerList[0].servicerName;
                            self.adjustApplyFormInfo = Utils.merge({}, adjustApplyFormInfo);
                            //
                            self.getShareAccWarehouseList(sharaAccServicerList[0].servicerId);
                        }
                        //
                        self.sharaAccServicerListMap = sharaAccServicerList.toMap("servicerId");
                        self.sharaAccServicerList = sharaAccServicerList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getShareAccWarehouseList: function (servicerId) {
                let self = this;
                let theLoad = MsgBox.loading();
                let postData = {
                    servicerId: servicerId,
                    custComId: self.thisComId
                };
                shareAccApi.getShareAccWarehouseList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let sharaAccWarehouseList = result.data;
                        //
                        if(sharaAccWarehouseList != null && sharaAccWarehouseList.length > 0) {
                            let adjustApplyFormInfo = self.adjustApplyFormInfo;
                            adjustApplyFormInfo.warehouseId = sharaAccWarehouseList[0].warehouseId;
                            adjustApplyFormInfo.warehouseName = sharaAccWarehouseList[0].warehouseName;
                            self.adjustApplyFormInfo = Utils.merge({}, adjustApplyFormInfo);
                        }
                        self.sharaAccWarehouseListMap = sharaAccWarehouseList.toMap("warehouseId");
                        self.sharaAccWarehouseList = sharaAccWarehouseList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 服务商切换
            changeServicerInfo: function (servicerId) {
                let servicerInfo = this.sharaAccServicerListMap[servicerId];
                //
                let adjustApplyFormInfo = this.adjustApplyFormInfo;
                adjustApplyFormInfo.servicerId = servicerInfo.servicerId;
                adjustApplyFormInfo.servicerName = servicerInfo.servicerName;
                //
                adjustApplyFormInfo.warehouseId = null;
                adjustApplyFormInfo.warehouseName = null;
                this.adjustApplyFormInfo = Utils.merge({}, adjustApplyFormInfo);
                //
                this.getShareAccWarehouseList(servicerId);
            },
            // 仓库切换
            changeWarehouseInfo: function (warehouseId) {
                let warehouseInfo = this.sharaAccWarehouseListMap[warehouseId];
                //
                let adjustApplyFormInfo = this.adjustApplyFormInfo;
                adjustApplyFormInfo.warehouseId = warehouseInfo.warehouseId;
                adjustApplyFormInfo.warehouseName = warehouseInfo.warehouseName;
                this.adjustApplyFormInfo = Utils.merge({}, adjustApplyFormInfo);
                // 获取共享配件信息
                // this.getShareAccStockByWarehouseId(warehouseInfo.warehouseId);
            },
            // 设置申请状态
            autoApplyChange: function () {
                // let adjustApplyFormInfo = this.adjustApplyFormInfo || {};
                //
                // adjustApplyFormInfo.autoApply = !adjustApplyFormInfo.autoApply;
            },
            upLoadApplyFiles: function () {
                let self = this;
                let params = {
                    auditAttrFlag: "Apply",
                    selectFileList: self.appturnFileList
                };
                openAdjustApplyFormFileUploadDlg(params, function (appturnFileList) {
                    self.appturnFileList = Utils.merge([], appturnFileList);
                });
            },
            //
            getShareAccStockByWarehouseId: function () {
                let self = this;
                let adjustApplyFormInfo = this.adjustApplyFormInfo;
                if(Utils.isNoB(adjustApplyFormInfo.warehouseId)) {
                    MsgBox.warning("请选择仓库信息");
                    return;
                }
                let itemList = adjustApplyFormInfo.itemList || [];
                let accIds = itemList.pluck("accId");
                // 申领选择配件
                openMerchtAccDefListSelectDlg(adjustApplyFormInfo.servicerId, accIds, function (accDefList) {
                    if(accDefList.length > 0) {
                        for(let i = 0; i < accDefList.length; i++) {
                            let accDefInfo = accDefList[i];
                            if(accIds.indexOf(accDefInfo.id) >= 0) {
                                continue;
                            }
                            let accItem = {};
                            accItem.accId = accDefInfo.id;
                            accItem.accName = accDefInfo.name;
                            accItem.catId = accDefInfo.catId;
                            accItem.catName = accDefInfo.catName;
                            accItem.catId1 = accDefInfo.catId1;
                            accItem.catId2 = accDefInfo.catId2;
                            accItem.catId3 = accDefInfo.catId3;
                            accItem.brandId = accDefInfo.brandId;
                            accItem.brandName = accDefInfo.brandName;
                            accItem.modelSpec = accDefInfo.modelSpec;
                            accItem.price = accDefInfo.price;
                            accItem.quantity = 1;
                            accItem.unit = accDefInfo.unit;
                            accItem.specificFlag = accDefInfo.specificFlag;
                            //
                            itemList.push(accItem);
                        }
                        adjustApplyFormInfo.itemList = Utils.merge([], itemList);
                        self.adjustApplyFormInfo = Utils.merge({}, adjustApplyFormInfo);
                    }
                });
//                showShareAccSelect(stockIds, null, adjustApplyFormInfo.warehouseId, function (stockList) {
//
//                }, false, true);
            },
            //
            inputQuantity: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入申请数量'));
                } else {
                    if(!Utils.isNumber(value) || value <= 0) {
                        callback(new Error('请输入大于0的数'));
                    } else {
                        callback();
                    }
                }
            },
            //
            removeAcc: function (index) {
                let itemList = this.adjustApplyFormInfo.itemList;
                itemList.removeAt(index);
                this.adjustApplyFormInfo.itemList = Utils.merge([], itemList);
            },
            //
            getDlgResult: function () {
                let result = {
                    type: 'warn'
                };
                //
                let adjustApplyFormInfo = this.adjustApplyFormInfo;
                if(Utils.isNoB(adjustApplyFormInfo.servicerId)) {
                    result.message = '请选择服务商';
                    return result;
                }
                if(Utils.isNoB(adjustApplyFormInfo.warehouseId)) {
                    result.message = '请选择仓库';
                    return result;
                }
                if(Utils.isNoB(adjustApplyFormInfo.accPreStkUsage)) {
                    result.message = '未确定备货用途';
                    return result;
                }
                if(Utils.isNoB(adjustApplyFormInfo.itemList) || adjustApplyFormInfo.itemList.length <= 0) {
                    result.message = '请选择配件信息';
                    return result;
                }
                // 申请附件信息
                if(adjustApplyFormInfo.autoApply) {
                    adjustApplyFormInfo.shareAccAdjustFileList = Utils.merge([], this.appturnFileList);
                }
                result.type = 'info';
                result.data = adjustApplyFormInfo;
                //
                return result;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/shareAcc/AdjustApplyFormSave.vue